import React from "react";
import { Modal, Button } from "react-bootstrap";

const BarcodeConfirmationModal = ({
  show,
  onHide,
  title = "Service Update",
  bodyContent,
  cancelLabel = "Exit registration",
  confirmLabel = "I understand, continue to register",
  onCancel,
  onConfirm,
  cancelClassName = "btn-cancel-dark",
  confirmClassName = "btn-confirm-pink",
}) => {
  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title className="enter-barcode-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {bodyContent ?? (
          <div className="enter-bardcode-confirmation-modal">
            <p>
              Following a recent service update, your test results may take up
              to 28 days to process. We'll always aim to deliver your results
              sooner whenever possible, and notify you as soon as your results
              are ready.
            </p>
            <p>
              If you have any questions, our Customer Care team is here to help
              at{" "}
              <a className="mail-href" href="mailto:care@myhealthchecked.com">
                care@myhealthchecked.com
              </a>
              .
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-center flex-column" >
        <Button className={cancelClassName} onClick={onCancel ?? onHide}>
          {cancelLabel}
        </Button>
        <Button className={confirmClassName} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeConfirmationModal;